module.exports = __webpack_public_path__ + "img/logo.e3fb680.png";